import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";

/**
 * The authenticated frame: a fixed sidebar and a scrolling main column. Every
 * screen renders into the Outlet, so navigation swaps the column and leaves the
 * sidebar in place.
 */
export function Layout() {
  return (
    <div className="flex min-h-dvh bg-gray-100">
      <Sidebar />
      <main className="min-w-0 flex-1">
        <Outlet />
      </main>
    </div>
  );
}
